import Transformer from './transformer';

export default class ProviderSubtypeTranformer extends Transformer {
  static fetchSubtype(items) {
    const newCollection = [];

    if (items.length === 0) {
      return newCollection;
    }

    items.forEach((data) => {
      newCollection.push({
        id: data.id,
        name_th: this.getLangName(data.name, 'th'),
        name_en: this.getLangName(data.name, 'en'),
        description_th: this.getLangName(data.description, 'th'),
        description_en: this.getLangName(data.description, 'en'),
        created_at: data.created_at,
        updated_at: data.updated_at,
        parent_id: data.parent_id,
        parent: this.fetchRarent,
      });
    });

    return newCollection;
  }

  static fetchRarent(item) {
    return {
      id: item.id,
      name_en: this.getLangName(item.name, 'en'),
      name_th: this.getLangName(item.name, 'th'),
      description_en: this.getLangName(item.description, 'en'),
      description_th: this.getLangName(item.description, 'th'),
      parent_id: item.parent_id,
      created_at: item.created_at,
      updated_at: item.updated_at,
    };
  }

  static getLangName(name, lang) {
    const nameObject = JSON.parse(name);

    return lang === 'en' ? nameObject.en : nameObject.th;
  }
}
